import ManualIcon from '../../assets/icons/document-manual.svg?react';
import type { Machine } from '../../gql/generated';

/** DocPortal of the same stage as this Pulse: DEV, QA or production. */
function docPortalOrigin(hostname: string): string {
  if (hostname.startsWith('pulse.qa.')) return 'https://docportal-qa.tomra.com';
  if (hostname.startsWith('pulse.dev.') || hostname === 'localhost') {
    return 'https://docportal-dev.tomra.com';
  }
  return 'https://docportal.tomra.com';
}

/**
 * The Documents tab. DocPortal holds the machine's manuals, spare part guides
 * and certificates, and finds them by serial number.
 */
export function MachineDocumentsLinkTab({ machine }: { machine: Machine }) {
  const serial = machine.serial;
  const href = serial
    ? `${docPortalOrigin(window.location.hostname)}/search?q=${encodeURIComponent(serial)}`
    : null;

  return (
    <div
      className='bg-surface-focus-support flex flex-col gap-3 px-4 pt-4 pb-10'
    >
      <h3 className='size-caption text-primary tracking-[0.08em] uppercase'>
        Documents
      </h3>
      <div
        className='bg-surface-primary border-border-secondary flex flex-col
          gap-4 rounded-xl border p-5 shadow-[0_4px_12px_rgba(0,0,0,0.03)]'
      >
        <div className='flex items-start gap-4'>
          <ManualIcon aria-hidden className='h-6 w-6 shrink-0' />
          <p className='size-p2 text-primary'>
            {serial ? (
              <>
                Manuals, spare part guides and certificates for serial{' '}
                <span className='font-bold'>{serial}</span> are in Tomra
                DocPortal.
              </>
            ) : (
              'This machine has no serial number, so DocPortal cannot find its documents.'
            )}
          </p>
        </div>
        {href && (
          <a
            href={href}
            target='_blank'
            rel='noreferrer'
            className='bg-brand-primary text-inverted size-p2 self-start
              rounded-lg px-4 py-2 font-bold'
          >
            Open in DocPortal
          </a>
        )}
      </div>
    </div>
  );
}
